import Vue, { PluginObject, VueConstructor } from 'vue';

export class RootElementAttrsHolder {
    protected readonly attrs: Attr[] = [];

    constructor(protected readonly el: Element) {
        this.attrs = Object.values(el.attributes);
    }

    public expose(app: Vue) {
        this.attrs.forEach(({ name, value }) => {
            // на случай если это comment
            if (typeof app.$el.setAttribute === 'function') {
                app.$el.setAttribute(name, value);
            }
        });
    }
}

function setRootAttrs(app: Vue) {
    app.$options.rootAttrs?.expose(app);
}

export const RootElementAttrsPlugin: PluginObject<Vue> = {
    install(Vue: VueConstructor) {
        Vue.mixin({
            mounted() {
                setRootAttrs(this as Vue);
            },
            updated() {
                setRootAttrs(this as Vue);
            },
        });
    },
};
